import React from 'react';

export const WebLink = ({ url }) => (
  <a className="privacy-link" href={url} target="_blank" rel="noopener noreferrer">
    {url}
  </a>
);
